<template>
  <section class="number-area ptb_30">
    <div class="mt-2 col-sm-6 col-md-12 col-lg-12 mb-3">
      <b-button class="bg-primary" v-b-modal.modal-illustration-kyaRyo
        >Vocabulary Illustration</b-button
      >
      <modal :modalId="'modal-illustration-kyaRyo'" :size="'xl'">
        <div slot="content">
          <b-img
            src="/assets/img/katakana/you-on/KatakanaKYA-RYO.jpg"
            fluid
            alt="Fluid image"
          ></b-img>
          <b-button v-for="illustration in vocab" :key="illustration.katakana" v-bind:style="illustration.styleButton" class="btn syllable" @click="play(illustration.katakana)"><p class="syllable text-white">{{ illustration.katakana }}</p></b-button>
        </div>
      </modal>
    </div>
    <div class="col-sm-12 col-lg-12 text-center">
      <b-row class="mt-2">
        <b-col
          class="mt-2"
          cols="12" md="2"
          v-for="syllable in syllabels"
          :key="syllable.original"
        >
          <b-card class="mb-2">
            <b-card-text>
              <h3 style="font-size:65px" class="syllable">{{ syllable.original }}</h3>
              <h5 class="mt-2 romaji">{{ syllable.romaji }}</h5>
              <b-button
                class="bg-success mt-3 ml-2"
                @click="play(syllable.original)"
                ><em class="mdi mdi-account-tie-voice"></em
              ></b-button>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <modal :modalId="'modal-syllable-kata-ao'">
        <div slot="content">
          <img
            class="img-fluid"
            alt="Responsive image"
            :src="imgSrc"
            width="100%"
          />
        </div>
      </modal>
    </div>
  </section>
</template>
<script>
import Modal from '../../../../Modal/Modal'
export default {
  components: { Modal },
  data () {
    return {
      syllabels: [
        {
          original: 'きゃ',
          romaji: 'kya'
        },
        {
          original: 'きゅ',
          romaji: 'kyu'
        },
        {
          original: 'きょ',
          romaji: 'kyo'
        },
        {
          original: 'しゃ',
          romaji: 'sha'
        },
        {
          original: 'しゅ',
          romaji: 'shu'
        },
        {
          original: 'しょ',
          romaji: 'sho'
        },
        {
          original: 'ちゃ',
          romaji: 'cha'
        },
        {
          original: 'ちゅ',
          romaji: 'chu'
        },
        {
          original: 'ちょ',
          romaji: 'cho'
        },
        {
          original: 'にゃ',
          romaji: 'nya'
        },
        {
          original: 'にゅ',
          romaji: 'nyu'
        },
        {
          original: 'にょ',
          romaji: 'nyo'
        },
        {
          original: 'ひゃ',
          romaji: 'hya'
        },
        {
          original: 'ひゅ',
          romaji: 'hyu'
        },
        {
          original: 'ひょ',
          romaji: 'hyo'
        },
        {
          original: 'みゃ',
          romaji: 'mya'
        },
        {
          original: 'みゅ',
          romaji: 'myu'
        },
        {
          original: 'みょ',
          romaji: 'myo'
        },
        {
          original: 'りゃ',
          romaji: 'rya'
        },
        {
          original: 'りゅ',
          romaji: 'ryu'
        },
        {
          original: 'りょ',
          romaji: 'ryo'
        },
        {
          original: 'ぎゃ',
          romaji: 'gya'
        },
        {
          original: 'ぎゅ',
          romaji: 'gyu'
        },
        {
          original: 'ぎょ',
          romaji: 'gyo'
        },
        {
          original: 'じゃ',
          romaji: 'ja'
        },
        {
          original: 'じゅ',
          romaji: 'ju'
        },
        {
          original: 'じょ',
          romaji: 'jo'
        },
        {
          original: 'びゃ',
          romaji: 'bya'
        },
        {
          original: 'びゅ',
          romaji: 'byu'
        },
        {
          original: 'びょ',
          romaji: 'byo'
        },
        {
          original: 'ぴゃ',
          romaji: 'pya'
        },
        {
          original: 'ぴゅ',
          romaji: 'pyu'
        },
        {
          original: 'ぴょ',
          romaji: 'pyo'
        }
      ],
      imgSrc: '',
      vocab: [
        {
          katakana: 'フィリピン',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'メニュー',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'コンピュータ',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'パーティー',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'チョーク',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'ジャズ',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'ファクス',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'ジューズ',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'フォーク',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        },
        {
          katakana: 'ワイシャツ',
          styleButton: {
            margin: '5px',
            padding: '5px 10px',
            backgroundColor: '#dc454a'
          }
        }
      ]
    }
  },
  methods: {
    showModal (val) {
      switch (val) {
      case 'ア':
        this.imgSrc = '/assets/gif/kataA-O/a-min.gif'
        break
      case 'イ':
        this.imgSrc = '/assets/gif/kataA-O/i-min.gif'
        break
      case 'ウ':
        this.imgSrc = '/assets/gif/kataA-O/u-min.gif'
        break
      case 'エ':
        this.imgSrc = '/assets/gif/kataA-O/e-min.gif'
        break
      case 'オ':
        this.imgSrc = '/assets/gif/kataA-O/o-min.gif'
        break
      case 'カ':
        this.imgSrc = '/assets/gif/kataKa-Ko/ka-min.gif'
        break
      case 'キ':
        this.imgSrc = '/assets/gif/kataKa-Ko/ki-min.gif'
        break
      case 'ク':
        this.imgSrc = '/assets/gif/kataKa-Ko/ku-min.gif'
        break
      case 'ケ':
        this.imgSrc = '/assets/gif/kataKa-Ko/ke-min.gif'
        break
      case 'コ':
        this.imgSrc = '/assets/gif/kataKa-Ko/ko-min.gif'
        break
      }
      this.$bvModal.show('modal-syllable-kata-ao')
    },
    play (val) {
      switch (val) {
      case 'きゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Kya-Kyo/Kya.mp3'
        break
      case 'きゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Kya-Kyo/Kyu.mp3'
        break
      case 'きょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Kya-Kyo/Kyo.mp3'
        break
      case 'しゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Sha-Sho/Sha.mp3'
        break
      case 'しゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Sha-Sho/Shu.mp3'
        break
      case 'しょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Sha-Sho/Sho.mp3'
        break
      case 'ちゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Cha-Cho/Cha.mp3'
        break
      case 'ちゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Cha-Cho/Chu.mp3'
        break
      case 'ちょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Cha-Cho/Cho.mp3'
        break
      case 'にゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Nya-Nyo/Nya.mp3'
        break
      case 'にゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Nya-Nyo/Nyu.mp3'
        break
      case 'にょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Nya-Nyo/Nyo.mp3'
        break
      case 'ひゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Hya-Hyo/Hya.mp3'
        break
      case 'ひゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Hya-Hyo/Hyu.mp3'
        break
      case 'ひょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Hya-Hyo/Hyo.mp3'
        break
      case 'みゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Mya-Myo/Mya.mp3'
        break
      case 'みゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Mya-Myo/Myu.mp3'
        break
      case 'みょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Mya-Myo/Myo.mp3'
        break
      case 'りゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Rya-Ryo/Rya.mp3'
        break
      case 'りゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Rya-Ryo/Ryu.mp3'
        break
      case 'りょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Rya-Ryo/Ryo.mp3'
        break
      case 'ぎゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Gya-Gyo/Gya.mp3'
        break
      case 'ぎゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Gya-Gyo/Gyu.mp3'
        break
      case 'ぎょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Gya-Gyo/Gyo.mp3'
        break
      case 'じゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Ja-Jo/Ja.mp3'
        break
      case 'じゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Ja-Jo/Ju.mp3'
        break
      case 'じょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Ja-Jo/Jo.mp3'
        break
      case 'びゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Bya-Byo/Bya.mp3'
        break
      case 'びゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Bya-Byo/Byu.mp3'
        break
      case 'びょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Bya-Byo/Byo.mp3'
        break
      case 'ぴゃ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Pya-Pyo/Pya.mp3'
        break
      case 'ぴゅ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Pya-Pyo/Pyu.mp3'
        break
      case 'ぴょ':
        this.soundSrc = '/assets/sounds/hiraganayou-on/Pya-Pyo/Pyo.mp3'
        break
      case 'フィリピン':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_firipin.mp3'
        break
      case 'メニュー':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_menyuu.mp3'
        break
      case 'コンピュータ':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_konpyuutaa.mp3'
        break
      case 'パーティー':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_paatii.mp3'
        break
      case 'チョーク':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_chooku.mp3'
        break
      case 'ジャズ':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_jazu.mp3'
        break
      case 'ファクス':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_fakusu.mp3'
        break
      case 'ジューズ':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_juusu.mp3'
        break
      case 'フォーク':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_fooku.mp3'
        break
      case 'ワイシャツ':
        this.soundSrc = '/assets/sounds/vocab-katakana/Katakana_KYA_waishatsu.mp3'
        break
      }
      const audio = new Audio(this.soundSrc)
      audio.play()
    }
  }
}
</script>
